import React from "react";
import { Box } from "@chakra-ui/react";
import PropTypes from "prop-types";
import shallow from "zustand/shallow";
import { useSelectedClassroomStore } from "@/stores/v2/selectedClassroomStore";
import { useClassroomSessionStore } from "@/stores/v2/classroomSessionStore";
import IconPencil from "@/js/components/svgr/IconPencil.js";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const EditClassButton = (props) => {
	const selectedClassroomStore = useSelectedClassroomStore(
		(state) => ({
			setData: state.setData,
		}),
		shallow
	);

	const handleClick = (ev) => {
		ev.stopPropagation();
		selectedClassroomStore.setData({ id: props.classroomId });
		useClassroomSessionStore.getState().handleShowEditClassModal({
			show: true,
			classroomName: props.classroomName,
			classExpiryStr: props.classExpiryStr,
			scheduledClass: props.scheduledClass,
			monitoring: props.isMonitoringClass,
		});
	};

	const getPencilColor = () => {
		if (props.scheduledClass) {
			return "Classroom_editButtonIcon--disabled";
		}
		if (props.blue) {
			return "Classroom_editButtonIcon--blue";
		}
		return "Classroom_editButtonIcon--normal";
	};

	const getButtonClass = () => {
		if (props.screenView) {
			return "ctxbar--Classroom_editButton";
		}
		if (props.isMonitoringClass === true) {
			return "Classroom_editButton Monitoring_pill";
		}
		return "Classroom_editButton";
	};

	return (
		<Box as="button" className={getButtonClass()} onClick={handleClick} aria-label="Edit class session" data-testid="edit-class-button">
			<span className={`Classroom_editButtonLabel${props.blue ? "--blue" : ""}`}>
				{props.children}
				{props.classExpiryStr ? (
					<IconPencil className={getPencilColor()} />
				) : (
					<div>
						<i className="fa fa-refresh fa-spin fa-fw inline-spinner-margin-left" />
					</div>
				)}
			</span>
		</Box>
	);
};

EditClassButton.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	blue: PropTypes.bool,
	scheduledClass: PropTypes.bool,
	isMonitoringClass: PropTypes.bool,
	classroomName: PropTypes.string,
	classExpiryStr: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	screenView: PropTypes.bool,
	classroomId: PropTypes.string.isRequired,
};

export default EditClassButton;
